import React, { useState, useRef } from 'react';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef([]);

  const faqs = [
    {
        question: "What is this site about?",
        answer: "We are a platform that helps users and sellers identify daily trends in products, provides summarized reviews from various e-commerce sites, and enables users to compare different products based on their queries."
    },
    {
        question: "What is the summarizer used for?",
        answer: "The summarizer helps users determine which product is best by consolidating reviews and information from multiple e-commerce sites."
    },
    {
        question: "What is the product comparator?",
        answer: "The product comparator allows users to compare two products based on the features they desire, helping them make informed decisions."
    },
    {
        question: "What is visual analytics?",
        answer: "Visual analytics is a feature available exclusively to sellers, providing visual metrics and insights about their products."
    },
    {
        question: "How do I operate the site?",
        answer: "Here is the link to the guide: [Insert Link]."
    },
    {
      question:"what is the use of the price tracker",
      answer : "when you want to track the price of your wished product.it helps in email alerts of prices for intervals of time for the user"
    }
];


  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className=" mx-auto p-8 bg-white rounded-3xl shadow-2xl w-[90vw]">
  <h2 className="text-3xl font-bold mb-10 text-center text-gray-800">
    FAQ
  </h2>
  
  <div className="space-y-0">
    {faqs.map((faq, index) => (
      <div 
        key={index} 
        className="border-b border-gray-200 last:border-b-0"
      >
        <button 
          onClick={() => toggleAccordion(index)}
          className={`
            w-full text-left p-5 flex justify-between items-center 
            ${activeIndex === index 
              ? 'bg-gray-50 text-gray-900' 
              : 'text-gray-800 hover:bg-gray-50'}
            transition-all duration-300 rounded-lg
          `}
        >
          <span className="text-lg font-semibold">
            {faq.question}
          </span>
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className={`
              h-6 w-6 transform transition-transform duration-300 
              ${activeIndex === index ? 'rotate-180' : 'rotate-0'}
            `}
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M19 9l-7 7-7-7" 
            />
          </svg>
        </button>
        
        <div 
          className={`
            overflow-hidden transition-all duration-300 ease-in-out
            ${activeIndex === index 
              ? 'max-h-96 opacity-100' 
              : 'max-h-0 opacity-0'}
          `}
        >
          <div className="p-5 text-gray-600 bg-white">
            <p className="leading-relaxed">
              {faq.answer}
            </p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

  );
};

export default FAQ;